import { styled } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import { useState, useEffect, createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { createPortal } from 'react-dom';
import { setOverflowForContainer } from './utils.js';

const _excluded = ["theme", "placement", "collapsed", "transitionSpeed"];
const getStyles = (placement, collapsed, theme) => {
  const placementStyles = {
    left: {
      left: 0,
      top: 0,
      bottom: 0,
      height: '100%',
      boxShadow: theme.shadows[4],
      transform: collapsed ? 'translateX(-100%)' : 'translateX(0)'
    },
    right: {
      right: 0,
      top: 0,
      bottom: 0,
      height: '100%',
      boxShadow: theme.shadows[4],
      // Unset to fix clipping of DateRangePicker inside sidepush panel (#1040371)
      transform: collapsed ? 'translateX(100%)' : 'unset'
    },
    top: {
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      boxShadow: theme.shadows[5],
      transform: collapsed ? 'translateY(-100%)' : 'translateY(0)'
    },
    bottom: {
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      boxShadow: '0px -3px 10px -1px rgba(0,0,0,0.12)',
      transform: collapsed ? 'translateY(100%)' : 'translateY(0)'
    }
  };
  return placementStyles[placement] || placementStyles.left;
};
const DrawerContentDiv = styled(Div).attrs(_ref => {
  let {
      theme,
      placement,
      collapsed,
      transitionSpeed
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({
    bg: theme.palette.common.white,
    zIndex: 101,
    overflow: 'hidden !important',
    position: 'absolute',
    boxShadow: 'none',
    transition: `transform ${transitionSpeed} linear`,
    width: '500px',
    height: '500px',
    maxWidth: '100%'
  }, getStyles(placement, collapsed, theme)), props);
})`
  ${({
  theme
}) => mediaMax(theme).xs`
    width: 100%;
  `};
`;

const Overlay = styled(Div)`
  content: '';
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  z-index: 100;
`;

const SideDrawer = ({
  placement = 'left',
  transitionSpeed = '0.2s',
  styles = {},
  getContainer,
  destroyOnCollapse = false,
  useOverlay = false,
  useContainerOverflowHidden = false,
  onMouseEnter,
  onMouseLeave,
  collapsed,
  children
}) => {
  const [container, setContainer] = useState(null);
  useEffect(() => {
    if (getContainer) {
      setContainer(getContainer());
      return;
    }
    setContainer(document.body);
  }, [getContainer]);
  const renderBody = () => {
    if (destroyOnCollapse) {
      return !collapsed ? children : null;
    }
    return children;
  };
  useEffect(() => {
    if (useContainerOverflowHidden) {
      setOverflowForContainer({
        container,
        placement,
        overflow: 'hidden'
      });
      return () => {
        setOverflowForContainer({
          container,
          placement,
          overflow: 'visible'
        });
      };
    }
    return () => {};
  }, [container, placement, useContainerOverflowHidden]);
  if (!container) return null;
  const renderDrawer = () => /*#__PURE__*/createElement(Fragment, null, useOverlay && !collapsed && /*#__PURE__*/createElement(Overlay, styles.overlay), /*#__PURE__*/createElement(DrawerContentDiv, _extends({}, styles.root, {
    collapsed: collapsed,
    placement: placement,
    transitionSpeed: transitionSpeed,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    testId: "drawerId",
    className: "drawer-panel"
  }), renderBody()));
  return /*#__PURE__*/createPortal(renderDrawer(), container);
};

export default SideDrawer;
